import { render, staticRenderFns } from "./StyledButton.vue?vue&type=template&id=5a1e588d&scoped=true"
import script from "./StyledButton.vue?vue&type=script&lang=js"
export * from "./StyledButton.vue?vue&type=script&lang=js"
import style0 from "./StyledButton.vue?vue&type=style&index=0&id=5a1e588d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e588d",
  null
  
)

export default component.exports